export default
{
    "status": 0,
    "data": {
        "CP_CD": "0801",
        "STORE_CD": "0001",
        "TNANT_CD": "0009",
        "SHOP_ID": "0003809",
        "POS_NO": "0005",
        "IS_SIMPLE_TOKEN": "N"
    },
    "message": ""
}